import {
  CheckCircle2,
  Clock,
  Download,
  RotateCcw,
  Upload,
  X,
  XCircle,
} from "lucide-react";
import React from "react";
import { useFormatAmount } from "../../hooks/useFormatAmount";

const SingleTransaction = ({ closeLoanTransaction, transaction }) => {
  const statusConfig = {
    completed: {
      styles: "bg-green-100 text-green-700",
      Icon: CheckCircle2,
    },
    successful: {
      styles: "bg-green-100 text-green-700",
      Icon: CheckCircle2,
    },
    pending: {
      styles: "bg-yellow-100 text-yellow-700",
      Icon: Clock,
    },
    reversed: {
      styles: "bg-purple-100 text-purple-700",
      Icon: RotateCcw,
    },
    declined: {
      styles: "bg-red-100 text-red-700",
      Icon: XCircle,
    },
  };

  // 2. In your JSX component:
  const currentStatus = transaction?.status?.toLowerCase() || "pending";
  const { styles, Icon } = statusConfig[currentStatus] || {
    styles: "bg-gray-100 text-gray-700",
    Icon: Clock, // Fallback icon
  };

  const formatAmount = useFormatAmount();
  return (
    <div
      onClick={closeLoanTransaction}
      className="fixed inset-0 bg-black/50 z-40 flex items-center justify-center"
    >
      <div
        onClick={(e) => e.stopPropagation()}
        className="w-[500px] h-[650px] rounded-[10px] p-[20px] relative bg-[#F3F3F3] overflow-y-auto shadow-lg"
      >
        {/* Close Button */}
        <div
          onClick={closeLoanTransaction}
          className="absolute top-[0px] cursor-pointer h-[40px] w-[40px] bg-[#D63B3B] rounded-tr-[10px] rounded-bl-[20px] right-[0px] flex items-center justify-center"
        >
          <X color="#ffffff" />
        </div>
        <div>
          {/* Title */}
          <p className="font-semibold text-center text-[#000000] text-[18px] mb-[20px]">
            Loan Transaction Details
          </p>
          <div className="h-[80px] w-full bg-[#E3F3EA] p-2 mb-5 rounded-[10px] ">
            <div className="w-full h-full flex items-center justify-between">
              <div className="flex items-center gap-5">
                <Upload size={23} color="#2A8C52" />
                <div className="flex flex-col">
                  <p className="text-[#000000] text-[14px] font-normal">
                    Loan Repayment to Loan
                  </p>
                  <p className="text-[#1E5D97] text-[14px] font-normal">
                    {transaction?.loanCode}
                  </p>
                </div>
              </div>
              <p className="text-[#2A8C52] font-semibold text-[20px]">
                + {formatAmount(transaction?.amount)}
              </p>
            </div>
          </div>
          <div className="h-[380px] w-full bg-white rounded-[10px] p-3 flex flex-col justify-around">
            <div className="flex items-center justify-between">
              <p className="text-[#5C5C5C] text-[16px] font-normal">
                Transaction ID
              </p>
              <p className="text-[#000000] text-[16px] font-normal">
                {transaction?.loanPublicId}
              </p>
            </div>
            <div className="flex items-center justify-between">
              <p className="text-[#5C5C5C] text-[16px] font-normal">Status</p>
              <div
                className={`flex items-center gap-1.5 px-3 py-1 rounded-full w-max text-[16px] font-normal capitalize ${styles}`}
              >
                <Icon className="w-4 h-4 shrink-0" />
                <span>{transaction?.status}</span>
              </div>
            </div>
            <div className="flex items-center justify-between">
              <p className="text-[#5C5C5C] text-[16px] font-normal">
                Amount(KES)
              </p>
              <p className="text-[#000000] text-[16px] font-normal">
                {formatAmount(transaction?.amount)}
              </p>
            </div>
            <div className="flex items-center justify-between">
              <p className="text-[#5C5C5C] text-[16px] font-normal">
                Transaction Type
              </p>
              <p className="text-[#000000] text-[16px] font-normal">
                {transaction?.transactionType}
              </p>
            </div>
            <div className="flex items-center justify-between">
              <p className="text-[#5C5C5C] text-[16px] font-normal">
                Payment Method
              </p>
              <p className="text-[#000000] text-[16px] font-normal">
                {transaction?.paymentMethod}
              </p>
            </div>
            <div className="flex items-center justify-between">
              <p className="text-[#5C5C5C] text-[16px] font-normal">
                Borrower Balance After Transaction
              </p>
              <p className="text-[#000000] text-[16px] font-normal">
                {formatAmount(transaction?.balanceAfterTransaction)}
              </p>
            </div>
            <div className="flex items-center justify-between">
              <p className="text-[#5C5C5C] text-[16px] font-normal">Borrower</p>
              <p className="text-[#000000] text-[16px] font-normal">
                {transaction?.borrower?.name}
              </p>
            </div>
          </div>
          <div className="w-full flex justify-center">
            <button className="my-6 flex items-center justify-center gap-3 bg-white rounded-[20px] px-[20px] text-[#000000] h-[44px]">
              <span>
                <Download />
              </span>
              Download Receipt
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SingleTransaction;
